import type Quill from 'quill';

import type { EmailEditorSuggestion } from './types';

export type ActiveTrigger = {
  triggerIndex: number;
  query: string;
};

export const replaceTriggerWithSuggestion = (
  quill: Quill,
  trigger: ActiveTrigger,
  suggestion: EmailEditorSuggestion,
  caretIndex: number,
  blotName: string,
): number => {
  const deleteLength = caretIndex - trigger.triggerIndex;
  const formats =
    deleteLength > 0 ? quill.getFormat(trigger.triggerIndex, deleteLength) : {};
  const link = typeof formats.link === 'string' ? formats.link : null;

  if (deleteLength > 0) {
    quill.deleteText(trigger.triggerIndex, deleteLength, 'user');
  }
  quill.insertEmbed(
    trigger.triggerIndex,
    blotName,
    { id: suggestion.id, display: suggestion.name },
    'user',
  );
  if (link != null) {
    quill.formatText(trigger.triggerIndex, 1, 'link', link, 'user');
  }
  return trigger.triggerIndex + 1;
};
